import React from "react";

/**
 * Panel opaco del teclado sobre lienzo oscuro (Escalas, Acordes, Canciones).
 */
export const PianoPracticePanel: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className = "" }) => (
  <div className={`flex flex-col justify-end w-full min-h-0 px-2 pb-2 ${className}`}>
    <div
      className="w-full rounded-t-xl rounded-b-md overflow-hidden border border-[#D8D4CC] bg-[#FAFAF8]"
      style={{
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.42), 0 1px 0 rgba(255, 255, 255, 0.08) inset",
      }}
    >
      {children}
    </div>
  </div>
);
